import { render } from "./ArchiveArrowDown.vue?vue&type=template&id=e45e22b6"
import script from "./ArchiveArrowDown.vue?vue&type=script&lang=js"
export * from "./ArchiveArrowDown.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArchiveArrowDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e45e22b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e45e22b6', __exports__)) {
    api.reload('e45e22b6', __exports__)
  }
  
  module.hot.accept("./ArchiveArrowDown.vue?vue&type=template&id=e45e22b6", () => {
    api.rerender('e45e22b6', render)
  })

}


export default __exports__